module.exports = __webpack_public_path__ + "static/media/chocolate-choco.0e10c123.png";